<div id='lv-container'>
    <div id='lv-clear' [inlineSVG]="'assets/images/broom.svg'" (click)='l.clear()'></div>
    <div id='lv-download' (click)='downloadLogFile()' [inlineSVG]="'assets/images/download.svg'"></div>
    <div id='lv-mail' *ngIf='ps.isAndroid()' (click)='sendMail()' [inlineSVG]="'assets/images/email.svg'"></div>
    <div id='lv-close' (click)='close()'>X</div>
    <div id='lv-log-list'>
        <div *ngFor='let iEntry of l.entries'><span class="lv-ts">{{dt.formatTime(iEntry.ts, 3)}} </span><span class="lv-tag">[{{iEntry.tag}}] </span><span>{{iEntry.val}}</span></div>
    </div>
</div>